import { render, staticRenderFns } from "./BackcallCard.vue?vue&type=template&id=ec675736&scoped=true&"
import script from "./BackcallCard.vue?vue&type=script&lang=js&"
export * from "./BackcallCard.vue?vue&type=script&lang=js&"
import style0 from "./BackcallCard.vue?vue&type=style&index=0&id=ec675736&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec675736",
  null
  
)

export default component.exports